<template>
	<div>
		<div class="top-module">
			<div class="top-leftsidebar">
				<div class="top-leftsidebar-top">
					<img src="@/assets/logo.png" class="logo-img">
					<img src="@/assets/title-1.png" class="title-1">
				</div>
				<img src="@/assets/title-2.png" class="title-2">
			</div>
			<div class="top-middlesidebar">
				<div class="search-bar" @click="search()" v-if="hideModelList.indexOf(0) < 0">
					<img src="@/assets/search-icon.png" class="search-icon">
					<input type="" name="" id="" value="" placeholder="请输入搜索内容" class="search-input" />
					<button type="button" class="search-btn">搜索</button>
				</div>
				<ul class="tag-list" v-if="hideModelList.indexOf(0) < 0 && hideModelList.indexOf(1) < 0">
					<li v-for="(item, index) in hotSearchList" :key="index" @click="search(item.title)">
						<a href="javascript:void(0)">{{item.title}}</a>
					</li>
				</ul>
				<ul class="tab-list" v-if="hideModelList.indexOf(2) < 0">
					<li v-for="(item,index) in tabList"
						:class="{active: $route.path == item.path}"
						@click="$router.push(item.path)"
						:key="index">
						<a href="javascript:void(0)">{{item.title}}</a>
					</li>
				</ul>
			</div>
			<div class="top-rightsidebar">
				<div class="top-rightsidebar-btnBox">
					<button type="button" @click="videoColumn">
						<img src="@/assets/icon-1.png">视频
					</button>
					<button type="button" @click="message">
						<img src="@/assets/icon-2.png">消息
					</button>
				</div>
				<div class="code-wrap">
					<div class="code-box">
						<img src="@/assets/code-1.png">
						扫码下载手机端
					</div>
					<div class="code-box">
						<img src="@/assets/code-1.png">
						微信扫码小程序
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { expediteGoodsTopSearch } from '../service/service';
	export default {
		name: 'header-search',
		props: {
			// 隐藏模块 逗号分隔
			// 0 搜索框、热搜
			// 1 热搜
			// 2 热搜下的菜单
			hideModel: {
				default: '',
			},
			// 搜索类型 0 商品 1 咨询
			searchType: {
				default: 0, // 默认 0 商品
			}
		},
		data() {
			return {
				//选项卡
				tabId: 0,
				tabList: [{
					title: "康养食品",
					path: '/my/my-health-food',
				}, {
					title: "亚健康汇",
					path: '/index/sub-health-pool',
				}, {
					title: "礼品心选",
					path: '/index/gift-heart-choose',
				}, {
					title: "促销精选",
					path: '/index/seconds-kill',
				}, {
					title: "限源预售",
					path: '/index/limited-source-pre-sale',
				}, {
					title: "优惠专区",
					path: '/my/message?tabId=2',
				}, {
					title: "加入我们",
					path: '/my/set-up?tabId=5',
				}],

				// 热搜
				hotSearchList: [],

				// 隐藏模块 逗号分隔
				// 0 搜索框、热搜
				// 1 热搜
				// 2 热搜下的菜单
				hideModelList: this.hideModel.split(',').map(str => parseInt(str)),
				
			}
		},
		mounted() {
			this.goodsTopSearch();
		},
		methods: {
			// 获取热搜
			goodsTopSearch() {
				expediteGoodsTopSearch().then(({ code, msg, data }) => {
					if (code == 1) {
						this.hotSearchList = data.list;
					} else {
						this.$message.error(msg);
					}
				});
			},
			//跳转搜索
			search(searchStr = '') {
				this.$router.push(`/index/search?type=${this.searchType}&searchStr=${searchStr}`);
			},
			//跳转视频专栏
			videoColumn() {
				this.$router.push('/index/video-column')
			},
			//跳转消息
			message() {
				this.$router.push('/my/message')
			},
		}
	}
</script>

<style scoped>
	
.top-module {
	width: 100%;
	height: 154px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: #FFFFFF;
	border-radius: 8px;
	margin-bottom: 10px;
	padding: 0 13px;
	box-sizing: border-box;
}

.top-leftsidebar {
	width: 226px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.top-middlesidebar {
	width: calc(100% - 536px);
	display: flex;
	flex-direction: column;
	margin: 0 10px;
}

.search-bar {
	width: 100%;
	height: 40px;
	border: 2px solid #F2501A;
	background-color: #FFFFFF;
	box-sizing: border-box;
	border-radius: 50px;
	display: flex;
	align-items: center;
}

.search-input {
	flex: 1;
	font-size: 12px;
}

.search-btn {
	width: 86px;
	height: 34px;
	line-height: 34px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50px;
	background-color: #F2501A;
	margin-right: 1.5px;
	color: #F8F8F8;
	font-size: 16px;
}

.placeholder {
	color: #919191;
}

.search-icon {
	width: 12px;
	height: 12px;
	margin-left: 12px;
	margin-right: 6px;
}

.tag-list {
	width: 100%;
	height: 50px;
	display: flex;
	flex-wrap: wrap;
	margin-top: 5px;
}

.tag-list>li {
	margin-right: 12px;
}

.tag-list>li>a {
	height: max-content;
	color: #505050;
	font-size: 12px;
}

.top-leftsidebar-top {
	display: flex;
	align-items: center;
}

.logo-img {
	width: 79px;
	margin-right: 21px;
}

.title-1 {
	width: 64px;
	margin-bottom: 15px;
}

.title-2 {
	width: 200px;
}

.top-rightsidebar {
	width: 290px;
	display: flex;
	align-items: flex-start;
}

.top-rightsidebar-btnBox {
	display: flex;
	align-items: center;
	margin-right: 23px;
}

.top-rightsidebar-btnBox button {
	width: max-content;
	display: flex;
	flex-direction: column;
	align-items: center;
	color: #505050;
	font-size: 12px;
	margin-right: 20px;
}

.top-rightsidebar-btnBox button:last-child {
	margin-right: 0;
}

.top-rightsidebar-btnBox button img {
	height: 22px;
	margin-bottom: 4px;
}

.code-wrap {
	display: flex;
	align-items: center;
}

.code-box {
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border: 1px solid #F2F2F2;
	border-radius: 4px;
	box-sizing: border-box;
	font-size: 9px;
	color: #F2501A;
	padding: 8px;
	margin-right: 20px;
}

.code-box:last-child {
	margin-right: 0;
}

.code-box>img {
	width: 60px;
	height: 60px;
	margin-bottom: 3px;
}
.tab-list {
	width: 100%;
	white-space: nowrap;
	overflow: auto;
}

.tab-list>li {
	display: inline-block;
	margin-right: 36px;
}

.tab-list>li:last-child {
	margin-right: 0;
}

.tab-list>li>a {
	color: #202020;
	font-size: 16px;
	font-weight: bold;
}

.tab-list>li.active>a {
	color: #F2501A;
}
</style>
